import { useEffect, useRef, useState } from 'react'

import { createPortal } from 'react-dom'

import ArrowIcon from '../ArrowIcon'
import './index.scss'

export default function MiraDemo() {
  const dialog = useRef(null)
  const frame = useRef(null)
  const launcher = useRef(null)
  const [loaded, setLoaded] = useState(false)
  const [expanded, setExpanded] = useState(false)

  const pause = () => frame.current?.contentWindow?.postMessage({ type: 'mira:pause' }, window.location.origin)
  const close = () => {
    pause()
    dialog.current?.close()
    launcher.current?.focus()
  }

  useEffect(() => {
    const message = event => {
      if (event.origin !== window.location.origin || event.source !== frame.current?.contentWindow) return
      if (event.data?.type === 'mira:close') close()
      if (event.data?.type === 'mira:expand') setExpanded(value => !value)
    }
    const visibility = () => { if (document.hidden) pause() }
    window.addEventListener('message', message)
    document.addEventListener('visibilitychange', visibility)
    return () => {
      window.removeEventListener('message', message)
      document.removeEventListener('visibilitychange', visibility)
    }
  }, [])

  return <>
    <div className="mira-demo-launch">
      <button ref={launcher} type="button" onClick={() => { setLoaded(true); dialog.current.showModal() }}>
        Open interactive demo <ArrowIcon />
      </button>
      <p>Interactive concept · Explore 3D controls, editable parameters, and calculated comparisons in MIRA’s scientific workspace.</p>
    </div>
    {createPortal(<dialog ref={dialog} className={`mira-demo-modal${expanded ? ' expanded' : ''}`} aria-label="MIRA interactive concept demo" onCancel={event => { event.preventDefault(); close() }}>
      <div className="mira-demo-toolbar">
        <span>MIRA / INTERACTIVE CONCEPT</span>
        <div><button type="button" onClick={() => setExpanded(value => !value)} aria-label={expanded ? 'Restore demo size' : 'Expand demo'}>{expanded ? 'Restore' : 'Expand'}</button><button type="button" onClick={close}>Close</button></div>
      </div>
      {loaded && <iframe ref={frame} src="/demos/mira/index.html?embed=1" title="MIRA interactive scientific workspace" allow="fullscreen" />}
    </dialog>, document.body)}
  </>
}
